// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1UA8c","label":"Section_label__3dPzZ","contentWrap":"Section_contentWrap__uRD01","footer":"Section_footer__1AQuD","footerInner":"Section_footerInner__2J0D7"};